import { UserRole } from '@/models/User';
import { AdminHomePath } from '@/modules/admin/paths';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { LoginPath } from '@/modules/auth/paths';
import { RetailerHomePath } from '@/modules/retailer/paths';
import { ShopPath } from '@/modules/store/paths';
import { SupplierHomePath } from '@/modules/supplier/paths';
import { Navigate } from 'react-router-dom';

const Home = () => {
  const { isLoggedIn, role } = useAuth();

  if (isLoggedIn) {
    switch (role) {
      case UserRole.RetailerAdmin:
        return <Navigate to={RetailerHomePath} replace />;
      case UserRole.StoreManager:
        return <Navigate to={ShopPath.path} replace />;
      case UserRole.SupplierAdmin:
        return <Navigate to={SupplierHomePath} replace />;
      case UserRole.SystemAdmin:
        return <Navigate to={AdminHomePath} replace />;
    }
  }

  return <Navigate to={LoginPath} replace />;
};

export default Home;
